import React from 'react';
import {Paperclip, Image as ImageIcon} from 'lucide-react';
import {UserMessageItem} from '../../api/types';

const UserMessageItemView: React.FC<{item: UserMessageItem}> = ({item}) => (
    <div className="d-flex justify-content-end mb-2">
        <div
            className="bg-primary text-white rounded-3 px-3 py-2"
            style={{maxWidth: '85%', whiteSpace: 'pre-wrap'}}
        >
            {item.text}
            {(item.attachments?.length ?? 0) > 0 && (
                <div className="mt-1 small">
                    {item.attachments!.map(attachment => (
                        <div
                            key={attachment.attachmentId}
                            className="d-flex align-items-center gap-1"
                        >
                            {attachment.isImage ? (
                                <ImageIcon size={12} />
                            ) : (
                                <Paperclip size={12} />
                            )}
                            <span>{attachment.fileName}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    </div>
);

export default UserMessageItemView;
